export const CARD_ITEM_SELECTOR = ".card-item"
export const CARD_ITEM_SELECTOR_WITHOUT_USER = ".card-item:not(.user)"
